export default {
  type(type) {
    return {
      building: 'Building Door',
      floor: 'Floor Door',
      corridor: 'Corridor Door',
      commonroom: 'Common Door',
      room: 'Room',
      subroom: 'Sub Room',
      keytag: 'Keytag',
    }[type] || 'Unknown';
  },
  fwType(fwType) {
    const model = {
      1: 'IG200',
      2: 'IG200',
      3: 'IG200',
      4: 'IG200',
      60: 'IG404',
      71: 'IG300',
      72: 'IG301',
      73: 'IG302',
      74: 'IG400',
      75: 'IG400',
      76: 'IG400',
      81: 'IG300A/B',
      82: 'IG301',
      83: 'IG302/T',
      84: 'IG400',
      85: 'IG400',
      86: 'IG402',
      87: 'IG700',
      88: 'IG710',
      89: 'IG403',
      90: 'IG101M',
      91: 'IG303',
      92: 'IG404',
      93: 'IG720',
      94: 'IG304',
      128: 'IG100M',
      129: 'IG102M',
      130: 'IG103M',
      140: 'IG500',
      150: 'IG600',
      151: 'IG600',
      160: 'IG700',
      161: 'IG710',
      162: 'IG720',
      170: 'IG800',
      171: 'IG800',
      190: 'IG500MF',
      191: 'IG600MF',
      192: 'IG600MF',
      193: 'IG700MF',
      194: 'IG710MF',
      195: 'IG720MF',
      196: 'IG800MF',
      197: 'IG800MF',
    }[fwType] || 'Unknown';

    return `${model}(${fwType})`;
  },
};



// WEBPACK FOOTER //
// ./src/components/admin/doorlocks/doorlockFormatter.js